import useClientHydrated from './useClientHydrated';

function isMobileFirefoxUserAgent(userAgent = '') {
  const isFirefox = /Firefox|FxiOS/i.test(userAgent);
  const isMobile = /Android|Mobile|Tablet|iPhone|iPad|iPod/i.test(userAgent);
  return isFirefox && isMobile;
}

function useIsMobileFirefox() {
  const hydrated = useClientHydrated();

  if (!hydrated || typeof navigator === 'undefined') return false;

  return isMobileFirefoxUserAgent(navigator.userAgent || '');
}

export { isMobileFirefoxUserAgent, useIsMobileFirefox };
